var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-product"},[_c('BaseSvg',{staticClass:"buy-product__icon",attrs:{"name":"ico-basket","width":"10rem","height":"10rem"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-product__content"},[_c('h3',{staticClass:"buy-product__title"},[_vm._v(" Замовлення успішно оформлено ")]),_c('p',{staticClass:"buy-product__text"},[_vm._v(" Очікуйте дзвінок від кур'єра ")])])
}]

export { render, staticRenderFns }